import React from 'react';
import { PillarCard } from './PillarCard';
import { useFadeInOnScroll } from '../hooks/useFadeInOnScroll';

import type { Pillar } from './PillarCard';

const GlobeIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="24" cy="24" r="20" />
    <ellipse cx="24" cy="24" rx="10" ry="20" />
    <path d="M4 24h40" />
    <path d="M8 12h32" />
    <path d="M8 36h32" />
  </svg>
);

const ChartIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="28" width="8" height="14" rx="1" />
    <rect x="20" y="18" width="8" height="24" rx="1" />
    <rect x="34" y="8" width="8" height="34" rx="1" />
    <path d="M4 44h40" />
  </svg>
);

const PeopleIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="24" cy="14" r="6" />
    <path d="M12 40c0-6.627 5.373-12 12-12s12 5.373 12 12" />
    <circle cx="10" cy="18" r="4" />
    <path d="M2 38c0-4.418 3.582-8 8-8 1.5 0 2.9.4 4.1 1.1" />
    <circle cx="38" cy="18" r="4" />
    <path d="M46 38c0-4.418-3.582-8-8-8-1.5 0-2.9.4-4.1 1.1" />
  </svg>
);

const PILLARS: Pillar[] = [
  {
    icon: <GlobeIcon />,
    title: '193 Countries',
    description: 'Comprehensive bilateral profiles covering every UN member state',
  },
  {
    icon: <ChartIcon />,
    title: '40 Domains',
    description:
      'Geopolitical, economic, trade, cultural, innovation, and diplomatic dimensions analyzed with rank-based standardization',
  },
  {
    icon: <PeopleIcon />,
    title: '755+ Contributors',
    description:
      'Ambassadors, honorary consuls, and subject-matter experts providing first-hand diplomatic intelligence',
  },
];

export function ValueProposition() {
  const { ref, style } = useFadeInOnScroll<HTMLElement>();

  return (
    <section
      ref={ref}
      className="value-prop"
      aria-labelledby="value-prop-title"
      style={style}
    >
      <h2 id="value-prop-title" className="value-prop__title">
        What is the Bilateral Navigator?
      </h2>
      <p className="value-prop__subtitle">
        A data-driven diplomatic intelligence publication spanning 350+ pages
        across 40 thematic domains for every bilateral relationship.
      </p>
      <ul className="value-prop__pillars" role="list">
        {PILLARS.map((p) => (
          <PillarCard key={p.title} pillar={p} />
        ))}
      </ul>
    </section>
  );
}
